import Constant from '../constant'
import LunchApi from '../api/api'

export default {
  [Constant.LOGIN]: (state, payload) => {
    // state.logininfo.islogin = payload.islogin;
    console.log('## :: local storage savd: ' )
    if(payload.access_token=='')
    {
      state.access_token = payload.access_token
      state.user_name = ''
      state.login_state = false
    }
    else {
      state.access_token = payload.access_token
      state.user_name = payload.user_name
      state.login_state = true
    }
    localStorage.accessToken = state.access_token
    localStorage.login_state = state.login_state
    localStorage.user_name = state.user_name

    console.log('## localStorage.login_state -->' + state.login_state)
  },
  [Constant.BOARD_DETAIL]: (state, payload) => {
    state.board_detail = payload

    localStorage.board_detail_type = payload.type
    localStorage.board_detail_no = payload.contentsNo

    console.log(JSON.stringify(state.board_detail))
  },
  [Constant.FETCH_DEVICES]: (state, payload) => {
    // state.contact = payload.contact;
    state.devicelist = payload.devicelist
    LunchApi.debugOut(state.devicelist)
    for (var i = 0; i < state.devicelist.length; i++) {
       state.devicelist[i].selected = true
    }
    LunchApi.debugOut(state.devicelist)
    console.log('## Constant.FETCH_DEVICES ')
    console.log('## saved' + payload.devicelist)
  },
  [Constant.FETCH_USER_INFO]: (state, payload) => {
    // state.contact = payload.contact;
    console.log('##1 mutations Constant.FETCH_USER_INFO ' + JSON.stringify(payload.userinfo))
    state.account = payload.userinfo
    console.log('##2 mutations Constant.FETCH_USER_INFO ')
    localStorage.accountName = state.account.name
  },
  [Constant.INITIALIZE_CONTACT_ONE]: (state) => {
    state.contact = {no: '', name: '', tel: '', address: ''}
  },
  [Constant.CHANGE_IS_LOADING]: (state, payload) => {
    state.isloading = payload.isloading
  },
  [Constant.SAVE_MENU_SELECTION]: (state) => {
    var selectedMenu = []
    for (var i = 0; i < state.devicelist.length; i++) {
      if (state.devicelist[i].selected) selectedMenu.push(state.devicelist[i].no)
    }
    console.log('## ' + selectedMenu)
    state.selectedMenu = selectedMenu
  },

  [Constant.MAIN_STATE]: (state, payload) => {
    state.mainState = payload
    localStorage.menuIndex = state.mainState.menuIndex
    localStorage.subIndex = state.mainState.subIndex
    console.log('##=====> : ' + JSON.stringify(state.mainState.menuIndex))
    console.log('##2 : ' + JSON.stringify(state.mainState))
    console.log('##3 : ' + JSON.stringify(localStorage))
  },
  [Constant.FETCH_DEVICE_ONE]: (state, payload) => {
    state.devicesetting = payload
    console.log('## updated FETCH_DEVICE_ONE')
    console.log(state.devicesetting)
  },
  [Constant.INITIALIZE_DEVICE_ONE]: (state, payload) => {
    state.devicesetting = {
      no: 0,
      name: '',
      serial: '',
      dailysame: false,
      dailysetting: [
        { isuse: true, begin: '7:00', end: '9:00 ' },
        { isuse: true, begin: '11:30', end: '14:00 ' },
        { isuse: true, begin: '17:30', end: '19:00 ' }
      ],
      weeklysettings: [
        { dow: '0',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        },
        { dow: '1',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        },
        { dow: '2',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        },
        { dow: '3',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        },
        { dow: '4',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        },
        { dow: '5',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        },
        { dow: '6',
          setting: [
            { isuse: true, begin: '7:00', end: '9:00 ' },
            { isuse: true, begin: '11:30', end: '14:00 ' },
            { isuse: true, begin: '17:30', end: '19:00 ' }
          ]
        }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js